// アプリケーション設定
// 設置時に config.json を編集することで設定を変更可能

export interface AppConfig {
  // スタンプ画像のベースパス（相対パス）
  stampBasePath: string
  // スタンプのファイル名マッピング
  stampFilenames: { [key: number]: string }
}

// 設定のデフォルト値（config.json が読み込めない場合に使用）
const defaultConfig: AppConfig = {
  stampBasePath: './images/stamps',
  stampFilenames: {
    "1": "1_LEO-212-6.png",
    "2": "2_NEO-8-799.png",
    "3": "3_MEO-91299.png",
    "4": "4_MEO10-699.png",
    "5": "5_NEO13-799.png"
  }
}

// グローバル設定キャッシュ
let configCache: AppConfig | null = null

// config.json を動的に読み込む
export async function loadConfig(): Promise<AppConfig> {
  if (configCache) {
    return configCache
  }

  try {
    const response = await fetch('./config.json')
    if (!response.ok) {
      console.warn('config.json not found, using default config')
      configCache = defaultConfig
      return defaultConfig
    }
    const data = await response.json()
    configCache = data
    return data
  } catch (error) {
    console.error('Failed to load config.json, using default config:', error)
    configCache = defaultConfig
    return defaultConfig
  }
}

// 同期的にデフォルト設定を取得（初期化前の利用用）
export function getDefaultConfig(): AppConfig {
  return defaultConfig
}

export default defaultConfig
